
import Countdown from "react-countdown";
import S3 from '../assets/images/g3.png';
import Logo2 from '../assets/images/logo10.svg';
import S2 from '../assets/images/logo789.png';
import Menu from "../components/Menu";
import { Link } from 'react-scroll'


import "animate.css";
import { useEffect, useState } from 'react';
import { Element } from 'react-scroll';
import img10a from '../assets/images/img10a.png';
import img10b from '../assets/images/img10b.png';

import img2 from '../assets/images/l4.png';
import img3 from '../assets/images/l5.png';
import img4 from '../assets/images/l6.png';
import img5 from '../assets/images/l7.png';
import img6 from '../assets/images/l8.png';

import img8 from '../assets/images/l9.png';
import img9 from '../assets/images/img9.jpg';
import img1 from '../assets/images/l3.png';
import s1 from '../assets/images/l1.png';
import Footer from "../components/Footer.jsx";

import img10 from '../assets/images/img7.jpg';
import img11 from '../assets/images/img8.jpg';

import l2 from '../assets/images/l2.png';

const Home = () => {
	// page content
	const Completionist = () => <span></span>;
	const [msgBtn, setMsgBtn] = useState("BUY TICKETS NOW");
	useEffect(() => {

		let hcm = new Date().toLocaleString("en-US", { timeZone: "Asia/Ho_Chi_Minh" });

		console.log(hcm);
		var dt = new Date(hcm);
		console.log("getHours() : " + dt.getHours());
		console.log("getDate() : " + dt.getDate());
		if (dt.getDate() === 2 && dt.getHours() < 14) {
			setMsgBtn("TICKETS AVAILABLE FROM 3PM")
		} else {
			setMsgBtn("BUY TICKETS NOW")
		}

	}, []);

	var countDownDate = new Date("Sep 30, 2022 00:00:00").getTime();




	return (
		<div>

			<div className='section_top'>
				<div className='bg'></div>
				<video autoPlay loop id="video-background" className="out" muted="muted" playsInline>
					<source src="/video/video.mp4" type="video/mp4" ></source>
					Your browser does not support HTML5 video.
				</video>


				<div className='container'>
					<Menu></Menu>

					<div className='section1'>

						<div className='row'>
							<div className='col-xs-12 col-md-6'>
								<div className='web_title'>
									<img src={Logo2} alt="logo" className='wow fadeIn' data-wow-delay="0.5s" />
								</div>

							</div>
							<div className='col-xs-12 col-md-6'>

								<div className="blockBtnPartyMB">
								<Link href="#" to="blockBuy" spy={true} smooth={true} duration={300} className="btnPartyMB">
								{msgBtn}
									</Link>
								</div>
							</div>
						</div>








					</div>
				</div>

			</div>





			<div className='section2'>
				<div class="section_img1"><img src={s1} alt="img1" /></div>


				<div className='section_countdown'>
					<div className="countdown">
						<div className='countdownRun'>
							<Countdown date={countDownDate} daysInHours={false}
								renderer={props => {
									return <div>{props.days === 1 ? props.days + ' DAY' : props.days + ' DAYS'} {props.hours === 1 ? props.hours + 'HOUR' : props.hours + ' HOURS'}</div>
								}}>
								<Completionist />
							</Countdown>

						</div>

					</div>

				</div>
				<div className='clearfix'>

				</div>
				<div class="row_col row4"></div>

				<div className='clearfix'>

				</div>
				{/* <div className="row_col row4">

				</div>
				<div className='clearfix'>

				</div> */}
			</div>
			<div className='clearfix'>

			</div>
			<div className='section3'>
				<div className='web_title'>

				</div>

				<div className="countdown">

				</div>

			</div>

			<div className='clearfix'>

			</div>

			<div className='section4'>
				<p>			An inaugural Weekender of incredible music and culture over the Singapore race
					weekend; the medicinal dose of debauchery that we’re all hankering for.</p>

			</div>



			<Element name="lineup">
			<div className='section_img'>

				<img src={l2} alt="l2" />
					{/* <span className='text right'>FRIDAY 30 SEPT</span><span className='line'></span> */}

				</div>
			</Element>
			<div className='clearfix'></div>
			<div className='section_blue'>
			</div>
			<div className='clearfix'></div>

			<div className='section_img1'>
				<img src={img1} alt="img1" />
			</div>
			<div className='section_img2'>
				<img src={img2} alt="img2" />
			</div>

			<div className='section_img3'>
				<img src={img3} alt="img3" />
			</div>

			<div className='section_buy_ticket bg11'>
			<Link href="#" to="blockBuy" spy={true} smooth={true} duration={300} className="buy_tickets_now">
								{msgBtn}
									</Link>
				<div className='clearfix'></div>
			</div>

			<div className='section_img4'>
				<img src={img4} alt="img4" />
			</div>

			<div className='section_img5'>
				<img src={img5} alt="img5" />
			</div>
			<div className='clearfix'></div>
			<div className='section_img6'>
				<img src={img6} alt="img6" />
			</div>
			<div className='clearfix'></div>




			<div className='section_img'>
				<img src={img8} alt="img8" />
			</div>
			<div className='section_buy_ticket'>
			<Link href="#" to="blockBuy" spy={true} smooth={true} duration={300} className="buy_tickets_now">
								{msgBtn}
									</Link>
			</div>

			<div className='section_img'>
				<img src={img10} alt="img9" />
			</div>
			<div className='section_img'>
				<img src={img11} alt="img9" />
			</div>

			<div className='section_img'>
				<img src={img9} alt="img9" />
			</div>

			<div className='clearfix'></div>

			<div className='section_buy_ticket colorrr'>
			<Link href="#" to="blockBuy" spy={true} smooth={true} duration={300} className="buy_tickets_now">
								{msgBtn}
									</Link>				<div className='clearfix'></div>
			</div>


			<div className='section_img'>
				<img src={img10a} alt="img10a" />
			</div>


			<Element name="ticket">
				<div className='section_img'>
					<img src={img10b} alt="img10b" />
				</div>


				<div className='section6'>

					<div className='container'>
						<div className='row'>
							<div className='col-xs-12 col-md-3'>

								<div className='title'>
									SUPER EARLY BIRD

								</div>



								<div className='value'>
									$88
								</div>

							</div>


							<div className='col-xs-12 col-md-3'>

								<div className='title'>
									EARLY BIRD


								</div>



								<div className='value'>
									$118
								</div>

							</div>


							<div className='col-xs-12 col-md-3'>

								<div className='title'>
									ADVANCE

								</div>



								<div className='value'>
									$148</div>

							</div>

							<div className='col-xs-12 col-md-3'>

								<div className='title'>
									DAY OF EVENT


								</div>



								<div className='value'>
									$168
								</div>

							</div>

						</div>
					</div>



				</div>

				<div className="clearfix"></div>

				<Element name="blockBuy">
				<div id="shop-frame" data-url="https://shop.eventix.io/d6a22d50-64d1-11e9-9c13-b33ec566eaa1" ></div>
				</Element>



				<div className='section5 '>


					<span className='line'></span><span className='text'>VIP PACKAGES</span>
					<div className='clearfix'></div>
				</div>







				<div className='section7'>


					<div className='container'>
						<div className='row'>
							<div className='col-xs-12 col-md-6 pack1'>
								<div className='title'>
									GOLD PACKAGE
								</div>
								<div className='content1'>
									SGD 5,000 MINIMUM SPEND

								</div>
								<div className='content2'>
									Set within the VIP area, guests can expect an exclusive area, which can accommodate up to 10 persons. Included within the package are: entry tickets for 10 guests and a beverage
									package of champagne and spirits.
								</div>
								<a className='title2' href='mailto:tables@mandalamasters.com'>
									ENQUIRE HERE
								</a>
							</div>

							<div className='col-xs-12 col-md-6 pack1'>
								<div className='title'>
									PLATINUM PACKAGE
								</div>
								<div className='content1'>
									SGD 25,000 MINIMUM SPEND


								</div>
								<div className='content2'>
									Set within the VIP area, guests can expect a prime view of the stage, which can
									accommodate up to 20 persons. Included within the package are: entry tickets for 20 guests and a bespoke beverage package of champagne and spirits.
								</div>
								<a className='title2' href='mailto:tables@mandalamasters.com'>
									ENQUIRE HERE
								</a>
							</div>

						</div>

					</div>

				</div>
			</Element>
			<div className='section_nft'>

				<div className='container'>
					<div className='row'>
						<div className='col-md-12'>
							<div className='title'>
								NFT MANDALA GENESIS 250 PASS
							</div>
							<div className='desc'>For the ultimate VIP experience, the Mandala Genesis 250 Pass, the Club’s first NFT launching on Thursday 8 September will offer a
								glimpse into extraordinary IRL access and benefits, including a rooftop view of the race itself, exclusively for 250 holders.</div>
							<a className='link' href="https://mandala.club/mandala-genesis-pass/">FIND OUT MORE</a>
							<div className='logo'>

							</div>
						</div>
					</div>
				</div>

			</div>


			<Footer></Footer>


		</div>
	)
}

export default Home
